import { Injectable, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  private readonly router: Router;
  private readonly route: ActivatedRoute;

  constructor(private readonly injector: Injector) {
    this.router = this.injector.get(Router);
    this.route = this.injector.get(ActivatedRoute);
  }
  public redirectToLogin(): void {
    const allianceCode = this.route.snapshot.queryParamMap.get('allianceCode');

    if (allianceCode) {
      window.location.href = `${environment.alliancesUrl}/login?allianceCode=${allianceCode}`;
      return;
    }

    this.router.navigate(['/login']);
  }
}
